import { CalendarDays, MapPin, Clock } from "lucide-react";
import { fileUrl, formatDate } from "@/lib/api";

export const RequestInfo = ({ req, showAddress }) => (
  <div className="space-y-6" data-testid="request-info">
    <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-stone-600">
      <span className="flex items-center gap-1.5" data-testid="request-info-city"><MapPin className="h-4 w-4 text-stone-400" /> {req.city_name}</span>
      <span className="flex items-center gap-1.5" data-testid="request-info-date"><CalendarDays className="h-4 w-4 text-stone-400" /> Tanggal diinginkan: {formatDate(req.preferred_date)}</span>
      <span className="flex items-center gap-1.5"><Clock className="h-4 w-4 text-stone-400" /> Dibuat {formatDate(req.created_at)}</span>
    </div>
    {showAddress && req.address && (
      <p className="rounded-xl bg-stone-50 px-4 py-3 text-sm text-stone-700" data-testid="request-info-address"><span className="font-semibold">Alamat:</span> {req.address}</p>
    )}
    {req.answers?.length > 0 && (
      <dl className="grid gap-3 sm:grid-cols-2" data-testid="request-info-answers">
        {req.answers.map((a) => (
          <div key={a.key} className="rounded-xl border border-stone-200 px-4 py-3">
            <dt className="text-xs text-stone-500">{a.label}</dt>
            <dd className="mt-0.5 text-sm font-semibold text-stone-900">{String(a.value)}</dd>
          </div>
        ))}
      </dl>
    )}
    <div>
      <p className="text-xs font-semibold uppercase tracking-wider text-stone-500">Deskripsi</p>
      <p className="mt-2 whitespace-pre-line leading-relaxed text-stone-700" data-testid="request-info-description">{req.description}</p>
    </div>
    {req.photos?.length > 0 && (
      <div className="flex flex-wrap gap-3" data-testid="request-info-photos">
        {req.photos.map((p) => (
          <a key={p} href={fileUrl(p)} target="_blank" rel="noreferrer" className="h-24 w-24 overflow-hidden rounded-xl border border-stone-200">
            <img src={fileUrl(p)} alt="" className="h-full w-full object-cover" />
          </a>
        ))}
      </div>
    )}
  </div>
);
